export default __webpack_public_path__ + "static/media/arrow_gst_yono.b18b4103.png";